const getRecaptchaToken = (token) => {
  if (token) {
    return token
  }
  return new Promise((resolve) => {
    const hasRecaptchaWidget = async () => {
      const grecaptcha = window?.grecaptcha
      const hasExecute = grecaptcha?.execute

      if (hasExecute) {
        const recaptchaToken = await grecaptcha?.execute()

        if (recaptchaToken) {
          clearInterval(captchaTokenInterval)
          resolve(recaptchaToken)
        }
      }
    }
    const captchaTokenInterval = setInterval(hasRecaptchaWidget, 350)
  })
}

export default getRecaptchaToken
